// // import React, { useState, useEffect } from "react";
// // import { toast, ToastContainer } from "react-toastify";
// // import "react-toastify/dist/ReactToastify.css";
// // import axios from "axios";
// // import config from "../config";
// // import { useLocation, useNavigate } from "react-router-dom";

// // const baseUrl = config.baseURL;

// // const RegistrationSuccess = () => {
// //   const location = useLocation();
// //   const navigate = useNavigate();

// //   // Initial state: start with a 60s countdown or fetch from server
// //   const [resendToken, setResendToken] = useState(location.state?.resendToken);
// //   const [countdown, setCountdown] = useState(60);
// //   const [isTimerActive, setIsTimerActive] = useState(true);

// //   // 1. Initial Load: Check if we need to sync with the server's specific timestamp
// //   useEffect(() => {
// //     if (!resendToken) return;

// //     axios
// //       .post(`${baseUrl}/auth/resend-countdown`, { resendToken })
// //       .then((res) => {
// //         const lastSent = new Date(res.data.lastSent);
// //         const diff = Math.max(
// //           0,
// //           60 - Math.floor((Date.now() - lastSent) / 1000)
// //         );
// //         setCountdown(diff);
// //         if (diff > 0) setIsTimerActive(true);
// //       })
// //       .catch(() => {
// //         // If server check fails, we still keep our local 60s timer active
// //         setIsTimerActive(true);
// //       });
// //   }, [resendToken]);

// //   // 2. The Timer Logic
// //   useEffect(() => {
// //     let timer;
// //     if (isTimerActive && countdown > 0) {
// //       timer = setInterval(() => {
// //         setCountdown((prev) => prev - 1);
// //       }, 1000);
// //     } else if (countdown === 0) {
// //       setIsTimerActive(false);
// //       clearInterval(timer);
// //     }
// //     return () => clearInterval(timer);
// //   }, [isTimerActive, countdown]);

// //   // 3. Auto-login/Verify logic
// //   useEffect(() => {
// //     const autoLogin = async () => {
// //       const params = new URLSearchParams(location.search);
// //       const token = params.get("token");
// //       if (!token) return;

// //       try {
// //         const response = await axios.post(
// //           `${baseUrl}/auth/verify-email-frontend`,
// //           { token }
// //         );
// //         if (response.data?.accessToken) {
// //           localStorage.setItem("token", response.data.accessToken);
// //           toast.success("✅ Email verified! Redirecting...");
// //           setTimeout(() => navigate("/dashboard"), 1500);
// //         }
// //       } catch (err) {
// //         toast.error(err.response?.data?.msg || "Verification error.");
// //       }
// //     };
// //     autoLogin();
// //   }, [location.search, navigate]);

// //   // 4. Handle Resend Click (Restarts the counter)
// //   const handleResendClick = async () => {
// //     if (!resendToken) return toast.error("Resend token not available");

// //     try {
// //       const response = await axios.post(`${baseUrl}/auth/resend-verification`, {
// //         resendToken,
// //       });

// //       toast.success(response.data.msg || "Verification email sent!");

// //       // Reset logic: Restart the 60 second counter
// //       setCountdown(60);
// //       setIsTimerActive(true);
// //     } catch (err) {
// //       toast.error(err.response?.data?.msg || "Something went wrong");
// //     }
// //   };

// //   const progressWidth = (countdown / 60) * 100;

// //   return (
// //     <div style={styles.container}>
// //       <ToastContainer position="top-center" />

// //       <div style={styles.card}>
// //         <h1 style={styles.title}>Check Your Email</h1>
// //         <p style={styles.subtitle}>
// //           We've sent a verification link to your inbox. <br />
// //           Please verify your account to continue.
// //         </p>

// //         {/* Progress Bar Area */}
// //         <div style={styles.progressContainer}>
// //           <div style={{ ...styles.progressBar, width: `${progressWidth}%` }} />
// //         </div>

// //         <div style={styles.buttonContainer}>
// //           <button
// //             onClick={handleResendClick}
// //             disabled={countdown > 0}
// //             style={{
// //               ...styles.button,
// //               backgroundColor: countdown > 0 ? "#A6AAAD" : "#2E4053",
// //               cursor: countdown > 0 ? "not-allowed" : "pointer",
// //             }}
// //           >
// //             {countdown > 0
// //               ? `Resend available in ${countdown}s`
// //               : "Resend Verification Email"}
// //           </button>
// //         </div>

// //         <button onClick={() => navigate("/")} style={styles.linkButton}>
// //           Back to Login
// //         </button>
// //       </div>
// //     </div>
// //   );
// // };

// // const styles = {
// //   container: {
// //     display: "flex",
// //     alignItems: "center",
// //     justifyContent: "center",
// //     height: "100vh",
// //     backgroundColor: "#D1D8E0", // Matches your ERP background
// //     fontFamily: "'Poppins', sans-serif",
// //     padding: "20px",
// //   },
// //   card: {
// //     backgroundColor: "#FFFFFF",
// //     padding: "40px",
// //     borderRadius: "12px",
// //     boxShadow: "0px 10px 30px rgba(0,0,0,0.1)",
// //     textAlign: "center",
// //     maxWidth: "500px",
// //     width: "100%",
// //   },
// //   title: {
// //     fontSize: "28px",
// //     fontWeight: "bold",
// //     color: "#2E4053", // Matches your ERP Heading
// //     marginBottom: "16px",
// //   },
// //   subtitle: {
// //     fontSize: "16px",
// //     color: "#34495E",
// //     lineHeight: 1.6,
// //     marginBottom: "30px",
// //   },
// //   progressContainer: {
// //     width: "100%",
// //     height: "6px",
// //     backgroundColor: "#E0E0E0",
// //     borderRadius: "10px",
// //     marginBottom: "25px",
// //     overflow: "hidden",
// //   },
// //   progressBar: {
// //     height: "100%",
// //     backgroundColor: "#2E4053", // Dark blue progress
// //     transition: "width 1s linear",
// //   },
// //   button: {
// //     width: "100%",
// //     padding: "14px",
// //     border: "none",
// //     borderRadius: "8px",
// //     color: "#FFFFFF",
// //     fontWeight: "bold",
// //     fontSize: "16px",
// //     transition: "all 0.3s ease",
// //   },
// //   linkButton: {
// //     marginTop: "20px",
// //     background: "none",
// //     border: "none",
// //     color: "#2E4053",
// //     textDecoration: "underline",
// //     cursor: "pointer",
// //     fontSize: "14px",
// //   },
// // };

// // export default RegistrationSuccess;
// import React, { useState, useEffect } from "react";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import axios from "axios";
// import config from "../config";
// import { useLocation, useNavigate } from "react-router-dom";

// const baseUrl = config.baseURL;

// const RegistrationSuccess = () => {
//   const location = useLocation();
//   const navigate = useNavigate();

//   const [resendToken, setResendToken] = useState(location.state?.resendToken);
//   const [countdown, setCountdown] = useState(0);
//   const [progress, setProgress] = useState(0);

//   // 1. Initial Load: Sync countdown with backend
//   useEffect(() => {
//     if (!resendToken) return;

//     axios
//       .post(`${baseUrl}/auth/resend-countdown`, { resendToken })
//       .then((res) => {
//         const lastSent = new Date(res.data.lastSent);
//         const diff = Math.max(
//           0,
//           60 - Math.floor((Date.now() - lastSent.getTime()) / 1000)
//         );
//         setCountdown(diff);
//         setProgress(diff > 0 ? (diff / 60) * 100 : 0);
//       })
//       .catch(() => {});
//   }, [resendToken]);

//   // 2. Timer Logic
//   useEffect(() => {
//     let timer;
//     if (countdown > 0) {
//       timer = setTimeout(() => {
//         setCountdown((prev) => prev - 1);
//         setProgress(((countdown - 1) / 60) * 100);
//       }, 1000);
//     } else {
//       setProgress(0);
//     }
//     return () => clearTimeout(timer);
//   }, [countdown]);

//   // 3. Auto-verification logic
//   useEffect(() => {
//     const autoLogin = async () => {
//       const params = new URLSearchParams(location.search);
//       const token = params.get("token");
//       if (!token) return;

//       try {
//         const response = await axios.post(
//           `${baseUrl}/auth/verify-email-frontend`,
//           { token }
//         );
//         if (response.data?.accessToken) {
//           localStorage.setItem("token", response.data.accessToken);
//           toast.success("✅ Email verified! Redirecting...");
//           setTimeout(() => navigate("/dashboard"), 1500);
//         } else toast.error("Verification failed.");
//       } catch (err) {
//         toast.error(err.response?.data?.msg || "Verification error.");
//       }
//     };
//     autoLogin();
//   }, [location.search, navigate]);

//   // 4. Handle Resend (Restarts the counter)
//   const handleResendClick = async () => {
//     if (!resendToken) return toast.error("Resend token not available");

//     try {
//       const response = await axios.post(
//         `${baseUrl}/auth/resend-verification`,
//         { resendToken },
//         { headers: { "Content-Type": "application/json" } }
//       );

//       toast.success(response.data.msg);
//       setResendToken(response.data.resendToken);

//       // Sync timer again after resend
//       const lastSent = new Date(response.data.lastSent);
//       const diff = Math.max(
//         0,
//         60 - Math.floor((Date.now() - lastSent.getTime()) / 1000)
//       );
//       setCountdown(diff);
//       setProgress((diff / 60) * 100);
//     } catch (err) {
//       toast.error(err.response?.data?.msg || "Something went wrong");
//     }
//   };

//   return (
//     <div style={styles.container}>
//       <ToastContainer position="top-center" />

//       <div style={styles.card}>
//         <h1 style={styles.title}>Registration Successful!</h1>
//         <p style={styles.subtitle}>
//           We've sent a verification link to your email. <br />
//           Please check your inbox (and spam folder) to activate your account.
//         </p>

//         {/* Progress Bar */}
//         <div style={styles.progressBarContainer}>
//           <div style={{ ...styles.progressBar, width: `${progress}%` }} />
//         </div>

//         {/* Dynamic Resend Button */}
//         <div style={styles.buttonContainer}>
//           <button
//             onClick={handleResendClick}
//             disabled={countdown > 0}
//             style={{
//               ...styles.button,
//               backgroundColor: countdown > 0 ? "#A6AAAD" : "#2E4053",
//               color: "#FFFFFF",
//               cursor: countdown > 0 ? "not-allowed" : "pointer",
//             }}
//           >
//             {countdown > 0
//               ? `Resend available in ${countdown}s`
//               : "Resend Verification Email"}
//           </button>
//         </div>

//         <div style={styles.linkContainer}>
//           <a href="/" style={styles.link}>
//             Back to Homepage
//           </a>
//         </div>
//       </div>
//     </div>
//   );
// };

// const styles = {
//   container: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     height: "100vh",
//     backgroundColor: "#D1D8E0", // Light Gray background
//     fontFamily: "'Poppins', sans-serif",
//     padding: "20px",
//   },
//   card: {
//     backgroundColor: "#FFFFFF",
//     padding: "40px",
//     borderRadius: "12px",
//     boxShadow: "0px 10px 25px rgba(0, 0, 0, 0.05)",
//     textAlign: "center",
//     maxWidth: "450px",
//     width: "100%",
//   },
//   title: {
//     fontSize: "26px",
//     fontWeight: "bold",
//     color: "#2E4053", // Dark Blue
//     marginBottom: "15px",
//   },
//   subtitle: {
//     fontSize: "15px",
//     color: "#34495E",
//     lineHeight: 1.6,
//     marginBottom: "25px",
//   },
//   progressBarContainer: {
//     width: "100%",
//     height: "6px",
//     backgroundColor: "#EEEEEE",
//     borderRadius: "10px",
//     overflow: "hidden",
//     marginBottom: "25px",
//   },
//   progressBar: {
//     height: "100%",
//     backgroundColor: "#2E4053", // Dark Blue progress
//     transition: "width 1s linear",
//   },
//   buttonContainer: {
//     marginBottom: "20px",
//   },
//   button: {
//     width: "100%",
//     padding: "14px",
//     border: "none",
//     borderRadius: "8px",
//     fontWeight: "bold",
//     fontSize: "15px",
//     textTransform: "none",
//     transition: "background-color 0.3s ease",
//   },
//   linkContainer: {
//     marginTop: "10px",
//   },
//   link: {
//     color: "#2E4053",
//     textDecoration: "none",
//     fontSize: "14px",
//     fontWeight: "500",
//   },
// };

// export default RegistrationSuccess;

import React, { useState, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import config from "../config";
import { useLocation, useNavigate } from "react-router-dom";

const baseUrl = config.baseURL;

const RegistrationSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [resendToken, setResendToken] = useState(location.state?.resendToken);
  const [countdown, setCountdown] = useState(60);

  // 1. On mount: sync countdown with backend (no email sent)
  useEffect(() => {
    if (!resendToken) return;

    axios
      .post(`${baseUrl}/auth/resend-countdown`, { resendToken })
      .then((res) => setCountdown(res.data.waitSeconds || 0))
      .catch(() => setCountdown(60)); // fallback
  }, []);

  // 2. Countdown timer
  useEffect(() => {
    if (countdown <= 0) return;
    const timer = setTimeout(() => setCountdown((prev) => prev - 1), 1000);
    return () => clearTimeout(timer);
  }, [countdown]);

  // 3. Auto-verify when user clicks email link
  useEffect(() => {
    const autoLogin = async () => {
      const params = new URLSearchParams(location.search);
      const token = params.get("token");
      if (!token) return;

      try {
        const response = await axios.post(
          `${baseUrl}/auth/verify-email-frontend`,
          { token }
        );
        if (response.data?.accessToken) {
          localStorage.setItem("token", response.data.accessToken);
          toast.success("✅ Email verified! Redirecting...");
          setTimeout(() => navigate("/dashboard"), 1500);
        } else {
          toast.error("Verification failed.");
        }
      } catch (err) {
        toast.error(err.response?.data?.msg || "Verification error.");
      }
    };
    autoLogin();
  }, [location.search, navigate]);

  // 4. Resend click
  const handleResendClick = async () => {
    if (!resendToken) return toast.error("Resend token not available");

    try {
      const response = await axios.post(
        `${baseUrl}/auth/resend-verification`,
        { resendToken },
        { headers: { "Content-Type": "application/json" } }
      );

      toast.success(response.data.msg || "Verification email sent!");

      if (response.data.resendToken) {
        setResendToken(response.data.resendToken);
      }

      setCountdown(60);
    } catch (err) {
      const data = err.response?.data;

      // Sync countdown if rate-limited
      if (err.response?.status === 429 && data?.msg) {
        const match = data.msg.match(/(\d+)s/);
        if (match) setCountdown(parseInt(match[1]));
      }

      toast.error(data?.msg || "Something went wrong");
    }
  };

  const progress = (countdown / 60) * 100;

  return (
    <div style={styles.container}>
      <ToastContainer position="top-center" />

      <div style={styles.card}>
        <div style={styles.iconWrap}>✉️</div>

        <h1 style={styles.title}>Check Your Email</h1>
        <p style={styles.subtitle}>
          We've sent a verification link to your inbox.
          <br />
          Please check your spam folder too.
        </p>

        {/* Progress Bar — only show when counting down */}
        {countdown > 0 && (
          <div style={styles.progressBarContainer}>
            <div style={{ ...styles.progressBar, width: `${progress}%` }} />
          </div>
        )}

        <button
          onClick={handleResendClick}
          disabled={countdown > 0}
          style={{
            ...styles.button,
            backgroundColor: countdown > 0 ? "#A6AAAD" : "#2E4053",
            cursor: countdown > 0 ? "not-allowed" : "pointer",
          }}
        >
          {countdown > 0
            ? `Resend available in ${countdown}s`
            : "Resend Verification Email"}
        </button>

        <a href="/" style={styles.link}>
          ← Back to Homepage
        </a>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    backgroundColor: "#D1D8E0",
    fontFamily: "'Poppins', sans-serif",
    padding: "20px",
  },
  card: {
    backgroundColor: "#FFFFFF",
    padding: "48px 40px",
    borderRadius: "16px",
    boxShadow: "0px 10px 40px rgba(0,0,0,0.08)",
    textAlign: "center",
    maxWidth: "460px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  iconWrap: {
    fontSize: "48px",
    marginBottom: "4px",
  },
  title: {
    fontSize: "24px",
    fontWeight: "700",
    color: "#2E4053",
    margin: 0,
  },
  subtitle: {
    fontSize: "14.5px",
    color: "#34495E",
    lineHeight: 1.7,
    margin: 0,
  },
  progressBarContainer: {
    width: "100%",
    height: "5px",
    backgroundColor: "#EEEEEE",
    borderRadius: "10px",
    overflow: "hidden",
  },
  progressBar: {
    height: "100%",
    backgroundColor: "#2E4053",
    transition: "width 1s linear",
  },
  button: {
    width: "100%",
    padding: "14px",
    border: "none",
    borderRadius: "10px",
    color: "#FFFFFF",
    fontWeight: "600",
    fontSize: "15px",
    transition: "background-color 0.3s ease",
  },
  link: {
    color: "#2E4053",
    textDecoration: "none",
    fontSize: "13.5px",
    fontWeight: "500",
    opacity: 0.75,
  },
};

export default RegistrationSuccess;
